import { css } from 'styled-components';
import token from 'styled-token';
import { StyledImage } from '../../components/Image/Image.styles';
import { spaceMixin } from '../spaceMixin';

/** @class PropertyCardMLSLogoMixin */
/** @method */
export var PropertyCardMLSLogoMixin = function PropertyCardMLSLogoMixin(props) {
  return token({
    maxHeight: 'PropertyCard.mls.logo.maxHeight',
    maxWidth: 'PropertyCard.mls.logo.maxWidth'
  }, function (_ref) {
    var maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth;
    return css(["display:grid;grid-area:mls-logo;justify-items:end;padding:", ";", "{max-height:", "px;max-width:", "px;}"], spaceMixin(0.5)(props), StyledImage, maxHeight, maxWidth);
  })(props);
};